import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';

export default function ProspectsClients() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.PROSPECTS_CLIENTS
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        }

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Prospects & Clients | Christian Clients | Kingdom Advisors</title>
                <meta name="description" content="Connect with Christian prospects and clients who are seeking biblical financial counsel. Enhance your reach and the impact of your financial advice." />
            </Head>
            <MarketingNavigation>
                <div className='prospects-and-clients'>
                    {articleBlocks && articleBlocks.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

ProspectsClients.getLayout = page => <>{page}</>;
ProspectsClients.isPublic = true;
